import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full grid grid-cols-2 pb-4" }
const _hoisted_2 = { class: "w-full grid grid-cols-1 py-4" }
const _hoisted_3 = { class: "w-full grid grid-cols-2 py-4" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "w-full grid grid-cols-2 py-4" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "w-full grid grid-cols-1 py-4" }
const _hoisted_12 = { class: "w-full grid grid-cols-1 py-4" }
const _hoisted_13 = {
  key: 0,
  class: "grid grid-cols-4 w-full gap-2"
}
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    width: "w-6/12",
    showFooter: false,
    onClose: () => _ctx.close(),
    title: _ctx.data.pdSttNo
  }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.requestType'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.rpdRequestType || "-"), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.lastStatus'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.sttLastStatusId || "-"), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.reason'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.pdReason || "-"), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.requestDate'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            (!_ctx.data.pdCreatedAt)
              ? (_openBlock(), _createBlock("div", _hoisted_4, " - "))
              : (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.data.formatCreatedAtNoTimeZone) + " " + _toDisplayString(_ctx.data.createdBy), 1))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.bkdDate'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            (!_ctx.data.pdBkdDate)
              ? (_openBlock(), _createBlock("div", _hoisted_6, " - "))
              : (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.data.formatPdBkdDate) + " " + _toDisplayString(`${_ctx.data.pdBkdByName ? `• ${_ctx.data.pdBkdByName}` : ""}`), 1))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.destination'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.sttDestinationCity || "-"), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.supportingLink'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            (_ctx.data.rpdLink.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.rpdLink, (link, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: `${index > 0 ? 'mt-2' : ''}`
                    }, [
                      _createVNode("a", {
                        href: _ctx.isValidLink(link),
                        target: "_blank",
                        class: "underline text-blue-lp-700",
                        style: {"word-break":"break-all","overflow-wrap":"break-word"}
                      }, _toDisplayString(link), 9, ["href"])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_10, "-"))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.notes'),
          class: "grid-cols-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.data.rpdNotes || "-"), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('urgentDeliveryManagement.detail.proofPhoto')
        }, {
          default: _withCtx(() => [
            (_ctx.data.rpdProofPhoto.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.rpdProofPhoto, (image) => {
                    return (_openBlock(), _createBlock("div", {
                      key: image,
                      class: ""
                    }, [
                      _createVNode("img", {
                        src: image,
                        alt: "",
                        class: "w-48 h-48 rounded-md",
                        onClick: () => _ctx.onPreview(image)
                      }, null, 8, ["src", "onClick"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_14, "-"))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createVNode(_component_ImagePreview, {
        modelValue: _ctx.photoPreview,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.photoPreview = $event)),
        data: _ctx.photoPreviews,
        image: _ctx.photo,
        isTerm: false
      }, null, 8, ["modelValue", "data", "image"])
    ]),
    _: 1
  }, 8, ["onClose", "title"]))
}